import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    type: "TINH", //string, optional // Loại vùng dịch là 1 trong 4 giá trị TINH,HUYEN,XA,DIADIEM
    province_id: null, //IdRef, optional // Tỉnh id
    district_id: null, //IdRef, optional // Huyện id
    commune_id: null, //IdRef, optional // Xã id
    address: null, //string, optional // Địa chỉ cụ thể
    lng: null, //double, optional // Kinh độ (longitude)
    lat: null, //double, optional // Vĩ độ (latitude)

    province_code: null, //string, optional // Mã tỉnh
    district_code: null, //string, optional // Mã huyện
    commune_code: null, //string, optional // Mã xã

    level: null, //string, optional, enum(DANG_DICH, DICH_GIAM, KHONG_30_NGAY, KHONG_60_NGAY, KHONG_90_NGAY) // Cấp độ (đang dịch/dịch đang giảm/không có người nhiễm dưới 30 ngày/dưới 60 ngày/dưới 90 ngày)
    number_of_infections: null, //integer, optional // Tổng số nhiễm bệnh
    number_of_recovery: null, //integer, optional // Tổng số phục hồi
    number_of_mortality: null, //integer, optional // Tổng số tử vong

    created_time: null, //datetime, optional // Thời gian tạo
    user_id: null, //IdRef, optional // Mã người dùng 

};

// validation form
model.validForm = {

    type: [], //string, optional // Loại vùng dịch là 1 trong 4 giá trị TINH,HUYEN,XA,DIADIEM
    province_id: [ValidService.required], //IdRef, optional // Tỉnh id
    district_id: [], //IdRef, optional // Huyện id
    commune_id: [], //IdRef, optional // Xã id
    address: [ValidService.required], //string, optional // Địa chỉ cụ thể
    lng: [ValidService.required], //double, optional // Kinh độ (longitude)
    lat: [ValidService.required], //double, optional // Vĩ độ (latitude)

    province_code: [], //string, optional // Mã tỉnh
    district_code: [], //string, optional // Mã huyện
    commune_code: [], //string, optional // Mã xã

    level: [], //string, optional, enum(DANG_DICH, DICH_GIAM, KHONG_30_NGAY, KHONG_60_NGAY, KHONG_90_NGAY) // Cấp độ (đang dịch/dịch đang giảm/không có người nhiễm dưới 30 ngày/dưới 60 ngày/dưới 90 ngày)
    number_of_infections: [ValidService.checkNumberInteger], //integer, optional // Tổng số nhiễm bệnh
    number_of_recovery: [ValidService.checkNumberInteger], //integer, optional // Tổng số phục hồi
    number_of_mortality: [ValidService.checkNumberInteger], //integer, optional // Tổng số tử vong
    
    created_time: [], //datetime, optional // Thời gian tạo
    user_id: [], //IdRef, optional // Mã người dùng 

    // ValidService.required   
};

// dữ liệu mẫu các form khác
model.dataFormOther = {       
};

// validation các form khác
model.validFormOther = {
};

model.types = [{
    code: "TINH",
    text: "Tỉnh"
},
{
    code: "HUYEN",
    text: "Huyện"
}
,
{
    code: "XA",
    text: "Xã"
}
,
{
    code: "DIADIEM",
    text: "Địa điểm"
}
];

model.levels = [{
    code: "DANG_DICH",
    text: "Đang dịch"
},
{
    code: "DICH_GIAM",
    text: "Dịch đang giảm"
}
,
{
    code: "KHONG_30_NGAY",
    text: "Không có người nhiễm dưới 30 ngày"
}
,
{
    code: "KHONG_60_NGAY",
    text: "Không có người nhiễm dưới 60 ngày"
}
,
{
    code: "KHONG_90_NGAY",
    text: "Không có người nhiễm dưới 90 ngày"
}
];

model.epidemic_status = [
    {
        code: "AN_TOAN",
        text: "An toàn"
    },
    {
        code: "CO_DICH",
        text: "Có dịch"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["created_time", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            type: '',
            province_id:'', 
            district_id:'', 
            commune_id:'', 
            address:'', 
            user_id:'',
            level:'',
            number_of_infections:'',
            number_of_recovery: '',
            number_of_mortality:'',
        },
        valid: {
            type: [],
            province_id:[], 
            district_id:[], 
            commune_id:[], 
            address:[], 
            user_id:[],
            level:[],
            number_of_infections:[],
            number_of_recovery: [],
            number_of_mortality: [],
        },
        operator: {
            // ten_nguoi_check_in: ":regex_i:", //:regex:, $vn_text=Viêt nam
            // ten_diem_den_an_toan: ":regex_i:",
            // thoi_diem_check_in: '>=',

            // type: '',
            // province_id:'', 
            // district_id:'', 
            // commune_id:'', 
            address:':regex_i:', 
            // user_id:'',
            number_of_infections: '>=',
            number_of_recovery: '>=',
            number_of_mortality: '>='
        }
    }
};

export default model;